// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --contact-bg: #f2f6fc;
  --contact-surface: #ffffff;
  --contact-surface-soft: #f7fbff;
  --contact-text: #122940;
  --contact-muted: #667e96;
  --contact-border: #d8e6f4;
  --contact-brand: #0f62ad;
  --contact-brand-dark: #0a4f8e;
  --contact-accent: #f6ba3b;
  --contact-shadow-soft: 0 10px 26px rgba(13, 37, 64, 0.08);
  --contact-shadow-raise: 0 16px 34px rgba(13, 37, 64, 0.13);
}

.contact-container {
  width: min(96%, 1160px);
  margin: 18px auto 0;
  color: var(--contact-text);
  background:
    radial-gradient(circle at 92% 4%, rgba(191, 216, 240, 0.38) 0%, rgba(191, 216, 240, 0) 35%),
    radial-gradient(circle at 8% 18%, rgba(255, 255, 255, 0.82) 0%, rgba(255, 255, 255, 0) 30%),
    linear-gradient(180deg, #f9fbff 0%, var(--contact-bg) 100%);
  border-radius: 24px;
  padding: clamp(16px, 2.8vw, 30px);
  box-sizing: border-box;
}

.contact-hero {
  text-align: center;
  padding: clamp(34px, 6vw, 62px) 20px;
  margin-top: 0;
  border-radius: 18px;
  background: linear-gradient(130deg, rgba(10, 44, 80, 0.96) 0%, rgba(16, 98, 173, 0.93) 100%);
  box-shadow: var(--contact-shadow-raise);
}

.contact-hero h1 {
  margin: 0;
  font-size: clamp(2rem, 4vw, 3rem);
  letter-spacing: 0.3px;
  color: #ffffff;
}

.contact-hero p {
  margin: 12px auto 0;
  max-width: 62ch;
  color: rgba(236, 246, 255, 0.95);
  font-size: clamp(0.98rem, 1.8vw, 1.15rem);
}

.contact-content {
  display: grid;
  grid-template-columns: minmax(0, 1.15fr) minmax(260px, 0.85fr);
  gap: 16px;
  padding: 18px 0 0;
  max-width: 1000px;
  margin: 0 auto;
}

.contact-form,
.contact-info {
  border: 1px solid var(--contact-border);
  border-radius: 16px;
  background: var(--contact-surface);
  box-shadow: var(--contact-shadow-soft);
}

.contact-form {
  padding: 22px;
}

.contact-form h2,
.contact-info h2 {
  margin: 0 0 12px;
  font-size: clamp(1.2rem, 2vw, 1.6rem);
  color: var(--contact-text);
}

.contact-form input,
.contact-form textarea {
  width: 100%;
  padding: 12px 13px;
  margin: 8px 0;
  border: 1px solid #cfdeee;
  border-radius: 10px;
  font-size: 14px;
  color: var(--contact-text);
  background: var(--contact-surface-soft);
  box-sizing: border-box;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
}

.contact-form input:focus,
.contact-form textarea:focus {
  outline: none;
  border-color: #9bc2e6;
  box-shadow: 0 0 0 3px rgba(15, 98, 173, 0.12);
}

.contact-form textarea {
  resize: vertical;
  min-height: 120px;
}

.contact-form button {
  width: 100%;
  min-height: 44px;
  margin-top: 8px;
  background: linear-gradient(120deg, var(--contact-brand) 0%, var(--contact-brand-dark) 100%);
  color: white;
  border: none;
  border-radius: 10px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 700;
  letter-spacing: 0.2px;
  transition: transform 0.2s ease, filter 0.2s ease;
}

.contact-form button:hover {
  transform: translateY(-1px);
  filter: brightness(1.04);
}

.contact-form button:disabled {
  cursor: not-allowed;
  opacity: 0.7;
}

.contact-info {
  padding: 20px;
  background:
    radial-gradient(circle at top right, rgba(248, 252, 255, 0.95) 0%, rgba(248, 252, 255, 0) 52%),
    var(--contact-surface);
}

.contact-info p {
  margin: 10px 0;
  color: var(--contact-muted);
  line-height: 1.55;
}

.contact-info strong {
  color: var(--contact-brand-dark);
  font-weight: 700;
}

@media (max-width: 900px) {
  .contact-content {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 768px) {
  .contact-container {
    width: 94%;
    border-radius: 16px;
    padding: 14px;
  }

  .contact-hero {
    border-radius: 14px;
    padding: 28px 14px;
  }

  .contact-form,
  .contact-info {
    border-radius: 12px;
    padding: 14px;
  }
}

/* Match shared Footer style with homepage */
.blue-text {
  color: #3391ff;
}

.yellow-text {
  color: #f3bd29;
}

.footer {
  --footer-bg: linear-gradient(140deg, #12283f 0%, #173b5d 52%, #1f4f78 100%);
  --footer-text: #e8f0f8;
  --footer-muted: #c7d5e3;
  --footer-border: rgba(255, 255, 255, 0.14);
  --footer-highlight: #f3bd29;
  margin: 70px 0 -12px;
  padding: 40px clamp(18px, 3vw, 42px) 18px;
  color: var(--footer-text);
  background: var(--footer-bg);
  border-top: 1px solid rgba(255, 255, 255, 0.08);
  box-shadow: 0 -18px 42px rgba(8, 29, 47, 0.2);
  box-sizing: border-box;
  font-family: "Segoe UI", Tahoma, Geneva, Verdana, sans-serif;
}

.footer-main {
  width: min(1240px, 100%);
  margin: 0 auto;
  display: grid;
  grid-template-columns: minmax(260px, 1.3fr) minmax(160px, 1fr) minmax(160px, 1fr) minmax(220px, 1.1fr);
  gap: clamp(18px, 3vw, 36px);
  align-items: flex-start;
}

.footer-brand-block {
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.footer-brand {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  text-decoration: none;
}

.footer-brand img {
  width: 64px;
  height: 64px;
  object-fit: contain;
}

.footer-brand h2 {
  margin: 0;
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: clamp(22px, 2.1vw, 28px);
  letter-spacing: 0.02em;
}

.footer-description {
  margin: 0;
  max-width: 34ch;
  color: var(--footer-muted);
  line-height: 1.65;
  font-size: 14px;
}

.footer-contact-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.footer-contact-list a {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  color: var(--footer-text);
  text-decoration: none;
  font-size: 14px;
  width: fit-content;
}

.footer-contact-list a:hover {
  color: var(--footer-highlight);
}

.footer-contact-list a svg {
  color: var(--footer-highlight);
  flex-shrink: 0;
}

.footer-link-group {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.footer-link-group h3,
.footer-social-block h3 {
  margin: 0 0 8px;
  font-size: 18px;
  color: #ffffff;
  letter-spacing: 0.01em;
}

.footer-link-group a {
  color: var(--footer-muted);
  text-decoration: none;
  font-size: 14px;
  width: fit-content;
  transition: color 0.2s ease;
}

.footer-link-group a:hover {
  color: #ffffff;
}

.footer-social-block {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.footer-social-block p {
  margin: 0;
  color: var(--footer-muted);
  line-height: 1.6;
  font-size: 14px;
}

.footer-social-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(120px, 1fr));
  gap: 10px;
}

.footer-social-item {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  height: 42px;
  border: 1px solid var(--footer-border);
  border-radius: 999px;
  color: #ffffff;
  text-decoration: none;
  font-size: 13px;
  font-weight: 600;
  background: rgba(255, 255, 255, 0.06);
  transition:
    transform 0.2s ease,
    background-color 0.2s ease,
    border-color 0.2s ease;
}

.footer-social-item:hover {
  transform: translateY(-2px);
  background: rgba(255, 255, 255, 0.14);
  border-color: rgba(255, 255, 255, 0.26);
}

.footer-bottom {
  width: min(1240px, 100%);
  margin: 28px auto 0;
  padding-top: 14px;
  border-top: 1px solid rgba(255, 255, 255, 0.16);
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 14px;
  color: var(--footer-muted);
  font-size: 13px;
}

.footer-bottom-links {
  display: flex;
  align-items: center;
  gap: 16px;
}

.footer-bottom-links a {
  color: var(--footer-muted);
  text-decoration: none;
}

.footer-bottom-links a:hover {
  color: #ffffff;
}

@media screen and (max-width: 1080px) {
  .footer-main {
    grid-template-columns: repeat(2, minmax(220px, 1fr));
  }
}

@media screen and (max-width: 768px) {
  .footer {
    margin-top: 48px;
    padding: 30px 16px 90px;
  }

  .footer-main {
    grid-template-columns: 1fr;
    gap: 24px;
  }

  .footer-social-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .footer-bottom {
    flex-direction: column;
    align-items: flex-start;
    font-size: 12px;
  }

  .footer-bottom-links {
    gap: 12px;
    flex-wrap: wrap;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/ContactPage/contact.css"],"names":[],"mappings":"AAAA;EACE,qBAAqB;EACrB,0BAA0B;EAC1B,+BAA+B;EAC/B,uBAAuB;EACvB,wBAAwB;EACxB,yBAAyB;EACzB,wBAAwB;EACxB,6BAA6B;EAC7B,yBAAyB;EACzB,yDAAyD;EACzD,0DAA0D;AAC5D;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,0BAA0B;EAC1B;;;+DAG6D;EAC7D,mBAAmB;EACnB,iCAAiC;EACjC,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,oCAAoC;EACpC,aAAa;EACb,mBAAmB;EACnB,4FAA4F;EAC5F,uCAAuC;AACzC;;AAEA;EACE,SAAS;EACT,iCAAiC;EACjC,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,gCAAgC;EAChC,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,8DAA8D;EAC9D,SAAS;EACT,iBAAiB;EACjB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;;EAEE,uCAAuC;EACvC,mBAAmB;EACnB,kCAAkC;EAClC,sCAAsC;AACxC;;AAEA;EACE,aAAa;AACf;;AAEA;;EAEE,gBAAgB;EAChB,qCAAqC;EACrC,0BAA0B;AAC5B;;AAEA;;EAEE,WAAW;EACX,kBAAkB;EAClB,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,0BAA0B;EAC1B,uCAAuC;EACvC,sBAAsB;EACtB,wDAAwD;AAC1D;;AAEA;;EAEE,aAAa;EACb,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,4FAA4F;EAC5F,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,iDAAiD;AACnD;;AAEA;EACE,2BAA2B;EAC3B,wBAAwB;AAC1B;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,aAAa;EACb;;0BAEwB;AAC1B;;AAEA;EACE,cAAc;EACd,2BAA2B;EAC3B,iBAAiB;AACnB;;AAEA;EACE,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE;IACE,UAAU;IACV,mBAAmB;IACnB,aAAa;EACf;;EAEA;IACE,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA;;IAEE,mBAAmB;IACnB,aAAa;EACf;AACF;;AAEA,4CAA4C;AAC5C;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,2EAA2E;EAC3E,sBAAsB;EACtB,uBAAuB;EACvB,0CAA0C;EAC1C,2BAA2B;EAC3B,oBAAoB;EACpB,yCAAyC;EACzC,yBAAyB;EACzB,4BAA4B;EAC5B,+CAA+C;EAC/C,6CAA6C;EAC7C,sBAAsB;EACtB,4DAA4D;AAC9D;;AAEA;EACE,wBAAwB;EACxB,cAAc;EACd,aAAa;EACb,sGAAsG;EACtG,2BAA2B;EAC3B,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,SAAS;EACT,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,mCAAmC;EACnC,sBAAsB;AACxB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,0BAA0B;EAC1B,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,SAAS;EACT,yBAAyB;EACzB,qBAAqB;EACrB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;EAC9B,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;;EAEE,eAAe;EACf,eAAe;EACf,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,0BAA0B;EAC1B,qBAAqB;EACrB,eAAe;EACf,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,SAAS;EACT,0BAA0B;EAC1B,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,oDAAoD;EACpD,SAAS;AACX;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,YAAY;EACZ,sCAAsC;EACtC,oBAAoB;EACpB,cAAc;EACd,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,qCAAqC;EACrC;;;0BAGwB;AAC1B;;AAEA;EACE,2BAA2B;EAC3B,qCAAqC;EACrC,uCAAuC;AACzC;;AAEA;EACE,wBAAwB;EACxB,mBAAmB;EACnB,iBAAiB;EACjB,+CAA+C;EAC/C,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,0BAA0B;EAC1B,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,0BAA0B;EAC1B,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,oDAAoD;EACtD;AACF;;AAEA;EACE;IACE,gBAAgB;IAChB,uBAAuB;EACzB;;EAEA;IACE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;IACE,gDAAgD;EAClD;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,eAAe;EACjB;;EAEA;IACE,SAAS;IACT,eAAe;EACjB;AACF","sourcesContent":[":root {\n  --contact-bg: #f2f6fc;\n  --contact-surface: #ffffff;\n  --contact-surface-soft: #f7fbff;\n  --contact-text: #122940;\n  --contact-muted: #667e96;\n  --contact-border: #d8e6f4;\n  --contact-brand: #0f62ad;\n  --contact-brand-dark: #0a4f8e;\n  --contact-accent: #f6ba3b;\n  --contact-shadow-soft: 0 10px 26px rgba(13, 37, 64, 0.08);\n  --contact-shadow-raise: 0 16px 34px rgba(13, 37, 64, 0.13);\n}\n\n.contact-container {\n  width: min(96%, 1160px);\n  margin: 18px auto 0;\n  color: var(--contact-text);\n  background:\n    radial-gradient(circle at 92% 4%, rgba(191, 216, 240, 0.38) 0%, rgba(191, 216, 240, 0) 35%),\n    radial-gradient(circle at 8% 18%, rgba(255, 255, 255, 0.82) 0%, rgba(255, 255, 255, 0) 30%),\n    linear-gradient(180deg, #f9fbff 0%, var(--contact-bg) 100%);\n  border-radius: 24px;\n  padding: clamp(16px, 2.8vw, 30px);\n  box-sizing: border-box;\n}\n\n.contact-hero {\n  text-align: center;\n  padding: clamp(34px, 6vw, 62px) 20px;\n  margin-top: 0;\n  border-radius: 18px;\n  background: linear-gradient(130deg, rgba(10, 44, 80, 0.96) 0%, rgba(16, 98, 173, 0.93) 100%);\n  box-shadow: var(--contact-shadow-raise);\n}\n\n.contact-hero h1 {\n  margin: 0;\n  font-size: clamp(2rem, 4vw, 3rem);\n  letter-spacing: 0.3px;\n  color: #ffffff;\n}\n\n.contact-hero p {\n  margin: 12px auto 0;\n  max-width: 62ch;\n  color: rgba(236, 246, 255, 0.95);\n  font-size: clamp(0.98rem, 1.8vw, 1.15rem);\n}\n\n.contact-content {\n  display: grid;\n  grid-template-columns: minmax(0, 1.15fr) minmax(260px, 0.85fr);\n  gap: 16px;\n  padding: 18px 0 0;\n  max-width: 1000px;\n  margin: 0 auto;\n}\n\n.contact-form,\n.contact-info {\n  border: 1px solid var(--contact-border);\n  border-radius: 16px;\n  background: var(--contact-surface);\n  box-shadow: var(--contact-shadow-soft);\n}\n\n.contact-form {\n  padding: 22px;\n}\n\n.contact-form h2,\n.contact-info h2 {\n  margin: 0 0 12px;\n  font-size: clamp(1.2rem, 2vw, 1.6rem);\n  color: var(--contact-text);\n}\n\n.contact-form input,\n.contact-form textarea {\n  width: 100%;\n  padding: 12px 13px;\n  margin: 8px 0;\n  border: 1px solid #cfdeee;\n  border-radius: 10px;\n  font-size: 14px;\n  color: var(--contact-text);\n  background: var(--contact-surface-soft);\n  box-sizing: border-box;\n  transition: border-color 0.2s ease, box-shadow 0.2s ease;\n}\n\n.contact-form input:focus,\n.contact-form textarea:focus {\n  outline: none;\n  border-color: #9bc2e6;\n  box-shadow: 0 0 0 3px rgba(15, 98, 173, 0.12);\n}\n\n.contact-form textarea {\n  resize: vertical;\n  min-height: 120px;\n}\n\n.contact-form button {\n  width: 100%;\n  min-height: 44px;\n  margin-top: 8px;\n  background: linear-gradient(120deg, var(--contact-brand) 0%, var(--contact-brand-dark) 100%);\n  color: white;\n  border: none;\n  border-radius: 10px;\n  cursor: pointer;\n  font-size: 14px;\n  font-weight: 700;\n  letter-spacing: 0.2px;\n  transition: transform 0.2s ease, filter 0.2s ease;\n}\n\n.contact-form button:hover {\n  transform: translateY(-1px);\n  filter: brightness(1.04);\n}\n\n.contact-form button:disabled {\n  cursor: not-allowed;\n  opacity: 0.7;\n}\n\n.contact-info {\n  padding: 20px;\n  background:\n    radial-gradient(circle at top right, rgba(248, 252, 255, 0.95) 0%, rgba(248, 252, 255, 0) 52%),\n    var(--contact-surface);\n}\n\n.contact-info p {\n  margin: 10px 0;\n  color: var(--contact-muted);\n  line-height: 1.55;\n}\n\n.contact-info strong {\n  color: var(--contact-brand-dark);\n  font-weight: 700;\n}\n\n@media (max-width: 900px) {\n  .contact-content {\n    grid-template-columns: 1fr;\n  }\n}\n\n@media (max-width: 768px) {\n  .contact-container {\n    width: 94%;\n    border-radius: 16px;\n    padding: 14px;\n  }\n\n  .contact-hero {\n    border-radius: 14px;\n    padding: 28px 14px;\n  }\n\n  .contact-form,\n  .contact-info {\n    border-radius: 12px;\n    padding: 14px;\n  }\n}\n\n/* Match shared Footer style with homepage */\n.blue-text {\n  color: #3391ff;\n}\n\n.yellow-text {\n  color: #f3bd29;\n}\n\n.footer {\n  --footer-bg: linear-gradient(140deg, #12283f 0%, #173b5d 52%, #1f4f78 100%);\n  --footer-text: #e8f0f8;\n  --footer-muted: #c7d5e3;\n  --footer-border: rgba(255, 255, 255, 0.14);\n  --footer-highlight: #f3bd29;\n  margin: 70px 0 -12px;\n  padding: 40px clamp(18px, 3vw, 42px) 18px;\n  color: var(--footer-text);\n  background: var(--footer-bg);\n  border-top: 1px solid rgba(255, 255, 255, 0.08);\n  box-shadow: 0 -18px 42px rgba(8, 29, 47, 0.2);\n  box-sizing: border-box;\n  font-family: \"Segoe UI\", Tahoma, Geneva, Verdana, sans-serif;\n}\n\n.footer-main {\n  width: min(1240px, 100%);\n  margin: 0 auto;\n  display: grid;\n  grid-template-columns: minmax(260px, 1.3fr) minmax(160px, 1fr) minmax(160px, 1fr) minmax(220px, 1.1fr);\n  gap: clamp(18px, 3vw, 36px);\n  align-items: flex-start;\n}\n\n.footer-brand-block {\n  display: flex;\n  flex-direction: column;\n  gap: 14px;\n}\n\n.footer-brand {\n  display: inline-flex;\n  align-items: center;\n  gap: 10px;\n  text-decoration: none;\n}\n\n.footer-brand img {\n  width: 64px;\n  height: 64px;\n  object-fit: contain;\n}\n\n.footer-brand h2 {\n  margin: 0;\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  font-size: clamp(22px, 2.1vw, 28px);\n  letter-spacing: 0.02em;\n}\n\n.footer-description {\n  margin: 0;\n  max-width: 34ch;\n  color: var(--footer-muted);\n  line-height: 1.65;\n  font-size: 14px;\n}\n\n.footer-contact-list {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.footer-contact-list a {\n  display: inline-flex;\n  align-items: center;\n  gap: 10px;\n  color: var(--footer-text);\n  text-decoration: none;\n  font-size: 14px;\n  width: fit-content;\n}\n\n.footer-contact-list a:hover {\n  color: var(--footer-highlight);\n}\n\n.footer-contact-list a svg {\n  color: var(--footer-highlight);\n  flex-shrink: 0;\n}\n\n.footer-link-group {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.footer-link-group h3,\n.footer-social-block h3 {\n  margin: 0 0 8px;\n  font-size: 18px;\n  color: #ffffff;\n  letter-spacing: 0.01em;\n}\n\n.footer-link-group a {\n  color: var(--footer-muted);\n  text-decoration: none;\n  font-size: 14px;\n  width: fit-content;\n  transition: color 0.2s ease;\n}\n\n.footer-link-group a:hover {\n  color: #ffffff;\n}\n\n.footer-social-block {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.footer-social-block p {\n  margin: 0;\n  color: var(--footer-muted);\n  line-height: 1.6;\n  font-size: 14px;\n}\n\n.footer-social-grid {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(120px, 1fr));\n  gap: 10px;\n}\n\n.footer-social-item {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  height: 42px;\n  border: 1px solid var(--footer-border);\n  border-radius: 999px;\n  color: #ffffff;\n  text-decoration: none;\n  font-size: 13px;\n  font-weight: 600;\n  background: rgba(255, 255, 255, 0.06);\n  transition:\n    transform 0.2s ease,\n    background-color 0.2s ease,\n    border-color 0.2s ease;\n}\n\n.footer-social-item:hover {\n  transform: translateY(-2px);\n  background: rgba(255, 255, 255, 0.14);\n  border-color: rgba(255, 255, 255, 0.26);\n}\n\n.footer-bottom {\n  width: min(1240px, 100%);\n  margin: 28px auto 0;\n  padding-top: 14px;\n  border-top: 1px solid rgba(255, 255, 255, 0.16);\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 14px;\n  color: var(--footer-muted);\n  font-size: 13px;\n}\n\n.footer-bottom-links {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n}\n\n.footer-bottom-links a {\n  color: var(--footer-muted);\n  text-decoration: none;\n}\n\n.footer-bottom-links a:hover {\n  color: #ffffff;\n}\n\n@media screen and (max-width: 1080px) {\n  .footer-main {\n    grid-template-columns: repeat(2, minmax(220px, 1fr));\n  }\n}\n\n@media screen and (max-width: 768px) {\n  .footer {\n    margin-top: 48px;\n    padding: 30px 16px 90px;\n  }\n\n  .footer-main {\n    grid-template-columns: 1fr;\n    gap: 24px;\n  }\n\n  .footer-social-grid {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n\n  .footer-bottom {\n    flex-direction: column;\n    align-items: flex-start;\n    font-size: 12px;\n  }\n\n  .footer-bottom-links {\n    gap: 12px;\n    flex-wrap: wrap;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
